<template>
	<Card>
		<Row style="padding-top: 20px;">
			<Form :label-width="80">
				<FormItem label="排行类型">
					<RadioGroup v-model="type" @on-change="search">
						<Radio label="1" border><span>分公司排行</span></Radio>
						<Radio label="2" border><span>大区排行</span></Radio>
						<Radio label="3" border><span>部门排行</span></Radio>
						<Radio label="4" border><span>个人业绩排行</span></Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="时间">
					<RadioGroup v-model="timePeriod" @on-change="changeDate">
						<Radio label="0" border><span>不限</span></Radio>
						<Radio label="1" border><span>今日</span></Radio>
						<Radio label="2" border><span>昨天</span></Radio>
						<Radio label="3" border><span>本周</span></Radio>
						<Radio label="4" border><span>上周</span></Radio>
						<Radio label="5" border><span>本月</span></Radio>
						<Radio label="6" border><span>上月</span></Radio>
						<Radio label="7" border><span>自定义</span></Radio>
						<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="changeTimePeriod"
							type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="筛选" v-if="type == 4">
					<Select v-model="followDepartment" @on-change="search" style="width:150px;" placeholder="部门">
						<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
					<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
				</FormItem>
				<FormItem label="系统类型" v-if="userInfo.role_type == 1">
					<RadioGroup v-model="channel_type" @on-change="search">
						<Radio label="0" border><span>全部</span></Radio>
						<Radio label="1" border><span>自营系</span></Radio>
						<Radio label="2" border><span>合作系</span></Radio>
					</RadioGroup>
				</FormItem>
				<p>
					备注：在行中有绿色项代表该客户经理系统开通时间在15天内
				</p>
			</Form>
		</Row>
		<Row>
			<div class="multiple" style="width: 100%">
				<Table :columns="columnsPersonalRank" border stripe :data="rankList" ref="table" v-if="type == 4 "
					:row-class-name="rowClassName" :index-method="getIndex">
					<template slot-scope="{ index,row }" slot="ranking">
						<span v-if="row.ranking ==1"> <img src="@/assets/images/ranking1.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==2"><img
								src="@/assets/images/ranking2.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==3"><img
								src="@/assets/images/ranking3.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking >=4">{{row.ranking}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="name">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="goToClickClientByname(row.id,row.name)">{{row.name}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="repay_money">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClickToSignList(4,row.id)">{{row.repay_money}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="sameperiod_last_month_repay_money">
						<div v-if="row.sameperiod_last_month_repay_money < row.repay_money">
							<span
								style="color:#63B3E6;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}</span><br>
							<span style="color:#ff0000;cursor: pointer;">
								(
								<Icon type="md-arrow-round-up" style="color: red;" />{{row.growth_rate}}
							</span>)
						</div>
						<div v-else-if="row.sameperiod_last_month_repay_money >= row.repay_money">
							<span
								style="color:#63B3E6;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}</span><br>
							<span style="color:#00ff00;cursor: pointer;">(
								<Icon type="md-arrow-round-down" style="color:#00ff00;" />{{row.growth_rate}})
							</span>
						</div>
					</template>
					<template slot-scope="{ index,row }" slot="visit_num">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="visitDataClick(row.id,1)">{{row.visit_num}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="sign_num">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,0,row.id,1,2)">{{row.sign_num}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="first_num">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClick(0,0,row.id,1,3)">{{row.first_num}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="get_money">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="clientClickToSignList(4,row.id)">{{row.get_money}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="call_data">
						<div>
							<span style="cursor: pointer;">通时：{{row.call_time}}</span>
						</div>
						<div>
							<span style="cursor: pointer;">通次：{{row.call_nums}}</span>
						</div>
					</template>
				</Table>
				<Table :columns="columnsSecondTeamRank" border stripe :data="rankList" ref="table" v-if=" type == 3">
					<template slot-scope="{ index,row }" slot="ranking">
						<span v-if="row.ranking ==1"> <img src="@/assets/images/ranking1.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==2"><img
								src="@/assets/images/ranking2.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==3"><img
								src="@/assets/images/ranking3.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking >=4">{{row.ranking}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="sameperiod_last_month_repay_money">
						<span v-if="row.sameperiod_last_month_repay_money < row.repay_money"
							style="color:#ff0000;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}<br>
							<Icon type="md-arrow-round-up" style="color: red;" />{{row.growth_rate}}
						</span>
						<span v-else-if="row.sameperiod_last_month_repay_money >= row.repay_money"
							style="color:#00ff00;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}<br>
							<Icon type="md-arrow-round-down" style="color:#00ff00;" />{{row.growth_rate}}
						</span>
					</template>
					<template slot-scope="{ index,row }" slot="name">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="departmentHistoryData(row.id,row.name)">{{row.name}}</span>
					</template>
				</Table>
				<Table :columns="columnsCompanyRank" border stripe :data="rankList" ref="table"
					v-if="type == 1 || type == 2 ">
					<template slot-scope="{ index,row }" slot="ranking">
						<span v-if="row.ranking ==1"> <img src="@/assets/images/ranking1.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==2"><img
								src="@/assets/images/ranking2.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking ==3"><img
								src="@/assets/images/ranking3.png" alt=""></span>
						<span style="color:#63B3E6;cursor: pointer;" v-if="row.ranking >=4">{{row.ranking}}</span>
					</template>
					<template slot-scope="{ index,row }" slot="sameperiod_last_month_repay_money">
						<span v-if="row.sameperiod_last_month_repay_money < row.repay_money"
							style="color:#ff0000;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}<br>
							<Icon type="md-arrow-round-up" style="color: red;" />{{row.growth_rate}}
						</span>
						<span v-else-if="row.sameperiod_last_month_repay_money >= row.repay_money"
							style="color:#00ff00;cursor: pointer;">{{row.sameperiod_last_month_repay_money}}<br>
							<Icon type="md-arrow-round-down" style="color:#00ff00;" />{{row.growth_rate}}
						</span>
					</template>
					<template slot-scope="{ index,row }" slot="visit_num">
						<span style="color:#63B3E6;cursor: pointer;"
							@click.stop="goToVisitNum(row.id)">{{row.visit_num}}</span>
					</template>
				</Table>
			</div>
		</Row>
		<Modal v-model="visitNumModal" width="1300">
			<VisitingCustomerReport ref="HistoryCreateMoney" :shop_id="shop_id" :type='2' :displayName="displayName">
			</VisitingCustomerReport>
		</Modal>
		<Modal v-model="visitDataModal" width="1200" title="来访客户">
			<TodayCustomer :follow_uid_props="get_uid" :timePeriod_props="timePeriod"
				:timePeriodDate_props="timePeriodDate"></TodayCustomer>
		</Modal>
		<Modal v-model="historyCreateMoneyShow" width="1500">
			<HistoryCreateMoney ref="HistoryCreateMoney" :userId="userId" :jumpType="jumpType"
				:departmentId="departmentId" :displayName="displayName"></HistoryCreateMoney>
		</Modal>
		<Modal v-model="clickJumpClientShow" width="1300" height="500">
			<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate"
				:get_uid="get_uid" :client_type="client_type" :start="start" :timeType="timeType" :status="status"
				:is_redistribution="is_redistribution"></ClickJumpClient>
		</Modal>
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getDepartmentList,
	} from '@/api/user'
	import {
		getRankList,
		getRankData
	} from "../../api/statics";
	import HistoryCreateMoney from '../statistics/HistoryCreateMoney.vue';
	import ClickJumpClient from '../client/ClickJumpClient.vue';
	import TodayCustomer from '../task/TodayCustomer.vue'
	import VisitingCustomerReport from '../task/VisitingCustomerReport.vue'

	export default {
		name: "performance_ranking",
		components: {
			HistoryCreateMoney,
			ClickJumpClient,
			VisitingCustomerReport,
			TodayCustomer
		},
		data() {
			return {
				timeType: '1',
				get_uid: '',
				status: 1,
				start: 0,
				client_type: 5,
				shop_id: '',
				followDepartment: '',
				departmentList: [],
				is_redistribution: 1,
				clickJumpClientShow: false,
				visitDataModal: false,
				timePeriod: '5',
				timePeriodDate: '',
				type: '4',
				channel_type:'1',
				jumpType: '',
				userId: '',
				departmentId: '',
				displayName: '',
				rankList: [],
				historyCreateMoneyShow: false,
				columnsPersonalRank: [{
						"title": "排位",
						"slot": 'ranking',
						"align": "center",
					},
					{
						"title": "贷款顾问",
						"slot": "name",
						"align": "center",
					},
					{
						"title": "分公司",
						"key": "company_name",
						"align": "center",
					},
					{
						"title": "上级部门",
						"key": "department_name",
						"align": "center",
					},
					{
						"title": "所属部门",
						"key": "department_name",
						"align": "center",
					},
					{
						"title": "状态",
						"key": "del",
						"align": "center",
						render: (h, params) => { // 根据条件判断内容重写
							switch (params.row.del) {
								case 0:
									return h('span', '在职')
								case 1:
									return h('span', '离职')
							}
						},
						"filteredValue": [0],
						filters: [ // 过滤条件 
							{
								label: '在职',
								value: '0'
							},
							{
								label: '离职',
								value: '1'
							},
						],
						filterMethod(value, row) { // 过滤方法
							return row.del == value
						}

					},
					{
						"title": "已确认邀约业绩",
						"key": "pass_invate_money",
						"align": "center",
					},
					{
						"title": "已确认谈单业绩",
						"key": "pass_assist_money",
						"align": "center",
					},
					{
						"title": "已确认业绩",
						"slot": "repay_money",
						"align": "center",
					},
					{
						"title": "未确认业绩",
						"key": "unconfirmed_repay_money",
						"align": "center",
					},
					{
						"title": "html",
						"slot": "sameperiod_last_month_repay_money",
						"align": "center",
						renderHeader: (h, params) => {
							var text = '上月同期';
							if (this.timePeriod == 1) {
								text = '昨日创收';
							} else if (this.timePeriod == 2) {
								text = '前天创收';
							} else if (this.timePeriod == 3) {
								text = '上周创收';
							} else if (this.timePeriod == 4) {
								text = '上上周创收';
							} else if (this.timePeriod == 5) {
								text = '上月同期';
							} else if (this.timePeriod == 6) {
								text = '上上月同期';
							} else if (this.timePeriod == 7) {
								text = '自定义同期';
							} else {
								text = '上月同期';
							}

							return h('div', {
								props: {},
							}, text);
						},
					},
					{
						"title": "上月业绩",
						"key": "last_month_repay_money",
						"align": "center",
					},
					{
						"title": "上门",
						"key": "visit_num",
						"align": "center",
					},
					{
						"title": "签约",
						"key": "sign_num",
						"align": "center",
					},
					{
						"title": "分配数",
						"key": "first_num",
						"align": "center",
					},
					{
						"title": "通时通次",
						"key": "call_data",
						"align": "center",
					},
					{
						"title": "批款额度（元）",
						"key": "get_money",
						"align": "center",
					},
					{
						"title": "平均点数",
						"key": "average_rate",
						"align": "center",
					}
				],
				columnsCompanyRank: [{
						"title": "排位",
						"slot": "ranking",
						"align": "center",
					},
					{
						"title": "分公司",
						"key": "company_name",
						"align": "center",
					},
					{
						"title": "负责人",
						"key": "principal_name",
						"align": "center",
					},
					{
						"title": "创收",
						"key": "repay_money",
						"align": "center",
					},
					{
						"title": "html",
						"slot": "sameperiod_last_month_repay_money",
						"align": "center",
						renderHeader: (h, params) => {
							var text = '上月同期';
							if (this.timePeriod == 1) {
								text = '昨日创收';
							} else if (this.timePeriod == 2) {
								text = '前天创收';
							} else if (this.timePeriod == 3) {
								text = '上周创收';
							} else if (this.timePeriod == 4) {
								text = '上上周创收';
							} else if (this.timePeriod == 5) {
								text = '上月同期';
							} else if (this.timePeriod == 6) {
								text = '上上月同期';
							} else if (this.timePeriod == 7) {
								text = '自定义同期';
							} else {
								text = '上月同期';
							}

							return h('div', {
								props: {},
							}, text);
						},
					},
					{
						"title": "上月业绩",
						"key": "last_month_repay_money",
						"align": "center",
					},
					{
						"title": "上门",
						"slot": "visit_num",
						"align": "center",
					},
					{
						"title": "签约",
						"key": "sign_num",
						"align": "center",
					},
					{
						"title": "分配数",
						"key": "first_num",
						"align": "center",
					},
					{
						"title": "批款额度",
						"key": "get_money",
						"align": "center",
					},
					{
						"title": "平均点数",
						"key": "average_rate",
						"align": "center",
					},
					{
						"title": "消耗",
						"key": "expendMoney",
						"align": "center",
					}
				],
				columnsCompanyRankCopy: [{
						"title": "排位",
						"slot": "ranking",
						"align": "center",
					},
					{
						"title": "分公司",
						"key": "company_name",
						"align": "center",
					},
					{
						"title": "负责人",
						"key": "principal_name",
						"align": "center",
					},
					{
						"title": "创收",
						"key": "repay_money",
						"align": "center",
					},
					{
						"title": "html",
						"slot": "sameperiod_last_month_repay_money",
						"align": "center",
						renderHeader: (h, params) => {
							var text = '上月同期';
							if (this.timePeriod == 1) {
								text = '昨日创收';
							} else if (this.timePeriod == 2) {
								text = '前天创收';
							} else if (this.timePeriod == 3) {
								text = '上周创收';
							} else if (this.timePeriod == 4) {
								text = '上上周创收';
							} else if (this.timePeriod == 5) {
								text = '上月同期';
							} else if (this.timePeriod == 6) {
								text = '上上月同期';
							} else if (this.timePeriod == 7) {
								text = '自定义同期';
							} else {
								text = '上月同期';
							}

							return h('div', {
								props: {},
							}, text);
						},
					},
					{
						"title": "上月业绩",
						"key": "last_month_repay_money",
						"align": "center",
					},
					{
						"title": "上门",
						"slot": "visit_num",
						"align": "center",
					},
					{
						"title": "签约",
						"key": "sign_num",
						"align": "center",
					},
					{
						"title": "分配数",
						"key": "first_num",
						"align": "center",
					},
					{
						"title": "批款额度",
						"key": "get_money",
						"align": "center",
					},
					{
						"title": "平均点数",
						"key": "average_rate",
						"align": "center",
					},
					{
						"title": "消耗",
						"key": "expendMoney",
						"align": "center",
					}
				],				
				columnsSecondTeamRank: [{
						"title": "排位",
						"key": "ranking",
						"align": "center",
					},
					{
						"title": "部门",
						"slot": "name",
						"align": "center",
					},
					{
						"title": "部门负责人",
						"key": "principal_name",
						"align": "center",
					},
					{
						"title": "业绩",
						"key": "repay_money",
						"align": "center",
					},
					{
						"title": "html",
						"slot": "sameperiod_last_month_repay_money",
						"align": "center",
						renderHeader: (h, params) => {
							var text = '上月同期';
							if (this.timePeriod == 1) {
								text = '昨日创收';
							} else if (this.timePeriod == 2) {
								text = '前天创收';
							} else if (this.timePeriod == 3) {
								text = '上周创收';
							} else if (this.timePeriod == 4) {
								text = '上上周创收';
							} else if (this.timePeriod == 5) {
								text = '上上月同期';
							} else if (this.timePeriod == 6) {
								text = '上月同期';
							} else if (this.timePeriod == 7) {
								text = '自定义同期';
							} else {
								text = '上月同期';
							}

							return h('div', {
								props: {},
							}, text);
						},
					},
					{
						"title": "上月业绩",
						"key": "last_month_repay_money",
						"align": "center",
					},
					{
						"title": "上门",
						"key": "visit_num",
						"align": "center",
					},
					{
						"title": "签约",
						"key": "sign_num",
						"align": "center",
					},
					{
						"title": "分配数",
						"key": "first_num",
						"align": "center",
					},
					{
						"title": "批款额度（元）",
						"key": "get_money",
						"align": "center",
					},
					{
						"title": "平均点数",
						"key": "average_rate",
						"align": "center",
					}
				],
				visitNumModal: false,
			}
		},
		props: ['menuName'],
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			menuName() {
				this.getList();
			}
		},
		mounted() {
			if (this.userInfo.role_type == 1 || this.userInfo.role_type == 3) {
				this.type = '1';
			}
			this.loadData();
			this.getList();
			this.userDisplayTable();
		},
		methods: {
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				var data = {
					token: that.token,
					getSelf: 1,
				};
				var res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getList() {
				let that = this;
				let data = {
					timePeriod: this.timePeriod,
					timePeriodDate: that.timePeriodDate,
					type: that.type,
					channel_type:that.channel_type,
					followDepartment: that.followDepartment,
				}
				data.token = this.token;
				let res = await getRankList(that, data);

				that.rankList = res.data.list;
			},
			departmentHistoryData(departantId, name) {
				let that = this;
				that.departmentId = departantId;
				that.jumpType = 2;
				that.displayName = name;
				that.userId = '';
				this.historyCreateMoneyShow = true;
			},
			userDisplayTable() {
				// type: 4 分公司负责人   5 区长n)
				if (this.userInfo.role_type !== 1) { //此处判断不用用户类型是否有有对应的列权限
					this.columnsCompanyRank = this.columnsCompanyRank.filter(col => col.key !== 'expendMoney')
				} else {
					this.columnsCompanyRank = this.columnsCompanyRankCopy
				}
			},
			visitDataClick(type_id, type) {
				let that = this;
				if (type == 1) {
					that.get_uid = type_id;
				} else {
					that.department_id = type_id;
				}
				that.visitDataModal = true;
			},
			goToVisitNum(shop_id) {
				console.log(shop_id)
				let that = this;
				that.shop_id = shop_id;
				that.visitNumModal = true;

			},
			initSearch() {
				this.timePeriod = '5';
				this.timePeriodDate = [];
				this.followDepartment = '',
					this.getList();
			},
			goToClickClientByname(userId, name) {
				let that = this;
				that.userId = userId;
				that.departmentId = '';
				that.displayName = name;
				that.jumpType = 1;
				this.historyCreateMoneyShow = true;
			},
			clientClickToSignList(timeType, add_uid) {
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：签约创建时间 3、进件时间 4、回款时间
				this.$router.push({
					name: 'ClickJumpSignClient',
					query: {
						add_uid: add_uid,
						timePeriod: this.timePeriod,
						timePeriodDate: this.timePeriodDate,
						timeType: timeType,

					}
				})
			},
			rowClassName(row, index) {
				var timestamp = Math.round(new Date().getTime() / 1000).toString() - 1296000;
				if (row.created_at >= timestamp) {
					return 'table-blue-row';
				} else {
					return 'table-black-row';
				}
			},
			clientClick(status, start, get_uid, timeType, client_type) {
				let that = this;
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				console.log(that.get_uid);
				console.log(that.start);
				that.status = status;
				that.start = start;
				that.get_uid = get_uid ? get_uid : 0;
				that.timeType = timeType;
				that.client_type = client_type;
				that.clickJumpClientShow = true;
				/*
				let routeData = this.$router.resolve({
				    name: 'ClickJumpClient',
				    query: {
						get_uid:get_uid,
						status:status,
						start:start,
						timePeriod:this.timePeriod,
						timePeriodDate:this.timePeriodDate,
						timeType:timeType
				    }
				})
				*/

			},
			search() {
				this.page = 1;
				this.getList();
			},
			changeDate(e) {
				this.getList();
			},
			changeTimePeriod(e) {
				this.timePeriodDate = e;
				console.log(this.timePeriodDate)
				this.getList();
			},
			getIndex(row, index) {
				console.log(row)
				return index + 0;
			}
		}
	}
</script>

<style scoped lang="less">
	.ranking_title {
		display: flex;

		div {
			width: 12%;
			height: 50px;
			text-align: center;
			line-height: 50px;
			font-size: 18px;
			font-weight: bold;
			color: #686868;
		}
	}

	.ranking_list {
		display: flex;
		margin: 20px 0;

		div {
			width: 12%;
			height: 50px;
			text-align: center;
			line-height: 50px;
			font-size: 18px;
			color: #9F9F9F;
		}
	}

	.ranking1 {
		background: url("../../assets/images/ranking1.png");
		color: #000066;
	}

	.ranking_img {
		font-size: 40px;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #00aa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>